import { TextualSeparatorDataType } from "../../interfaces/textualSeparator/TextualSeparator.type";
import TextualSeparator from "./TextualSeparator";

export default function TextualSeparatorContainer({items} : {items: TextualSeparatorDataType[]}) {
  const item = items[0];
  return ( 
    <div className="vas-w-100">
      <TextualSeparator item={item}/>
    </div>
  );
}
